export const calculateDefects = (
  defects: Array<{
    defectClassification: 'minor' | 'major' | 'critical';
    defectGroup: string;
    defectName: string;
    description: string;
    quantity: string | number;
    referenceMedia: number[];
  }>
) => {
  const total = { critical: 0, major: 0, minor: 0 };
  defects.forEach((defect) => {
    switch (defect.defectClassification) {
      case 'critical':
        total.critical += Number(defect.quantity);
        break;
      case 'major':
        total.major += Number(defect.quantity);
        break;
      case 'minor':
        total.minor += Number(defect.quantity);
        break;
      default:
        break;
    }
  });
  return total;
};
